import { IPaymentusSettings } from 'types';

import { Box, Button } from '@mui/material';

export interface PaymentusSettingsViewProps {
  data: IPaymentusSettings;
  isEditable: boolean;
  onEdit: () => void;
}

export default function PaymentusSettingsView(props: PaymentusSettingsViewProps) {
  const { data, onEdit, isEditable } = props;

  return (
    <>
      <Box sx={{ fontSize: '1.6rem', mb: 2 }}>
        Days we'll wait in case of ACH Paymentus payments to mark transaction as successful:{' '}
        <strong>{data.days}</strong>
      </Box>

      {isEditable && (
        <Box display="flex" alignItems="center" flexWrap="wrap" justifyContent="flex-end" mt={2}>
          <Button
            variant="contained"
            disableElevation
            onClick={() => {
              onEdit();
            }}
          >
            Edit
          </Button>
        </Box>
      )}
    </>
  );
}
